module.exports = __webpack_public_path__ + "static/media/liushishishan2.1c95db5e.webp";